import SlotPicker from "@/components/SlotPicker";
import { facetExamples } from "@/content/facetExamples";
import { useFacetStore } from "@/store/facetStore";
import { useConceptAxes } from "@/store/customContentStore";

/** Wires the generic SlotPicker to the Design Challenge facet selection store. */
export default function FacetPicker() {
  const s = useFacetStore();
  const axes = useConceptAxes();
  const order = axes.map((a) => a.key);
  const labels = Object.fromEntries(axes.map((a) => [a.key, a.label]));
  const pools = Object.fromEntries(axes.map((a) => [a.key, a.values]));

  return (
    <SlotPicker
      order={order}
      labels={labels}
      pools={pools}
      unit="axes"
      valueExamples={facetExamples}
      isEnabled={s.isAxisEnabled}
      isValueOn={s.isValueOn}
      activeCount={s.activeCount}
      activeAxisCount={s.activeAxisCount()}
      onToggleAxis={s.toggleAxis}
      onToggleValue={s.toggleValue}
      onSetAxisValues={s.setAxisValues}
      onEnableAll={s.enableAllAxes}
      onDisableAll={s.disableAllAxes}
      onReset={s.resetAll}
    />
  );
}
